import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RingLoader } from "react-spinners";
import { RootState } from "../../Redux/store";
import { Category } from "../Components/types";
import { slugify } from "../../utils/categoryPath";
import usePageMeta from "../../common/hooks/usePageMeta";
import useJsonLd from "../../common/hooks/useJsonLd";
import { breadcrumbSchema } from "../../common/seo/schema";
import { chawlaispat } from "../../Redux/apiRoutes";
import Items from "./Items";

/**
 * /c/:slug - SEO URL se category listing. Categories Navbar store me bharta hai;
 * jab tak list nahi aayi, loader; slug na mile to /categories.
 *
 * Hooks sab early return se PEHLE chalte hain (React ka rule) - isliye title/
 * schema loader wali state me bhi set ho jaate hain.
 */
const CategoryBySlug = () => {
  const { slug = "" } = useParams();
  const all = useSelector((state: RootState) => state.values.allCategories as Category[] | undefined);
  const list = Array.isArray(all) ? all : [];
  const hit = list.find((c) => slugify(String(c.name || "")) === slug.toLowerCase());
  const catName = hit ? String(hit.name || "") : "";

  usePageMeta(
    catName
      ? `${catName} Rate Today in Rudrapur | Price List | Chawla Ispat`
      : "Building Material Categories | Chawla Ispat Rudrapur",
    catName
      ? `${catName} ka aaj ka rate GST sahit - brand, size aur unit ke saath. Rudrapur godown se 1-2 din me delivery, GST invoice. Online order ya WhatsApp par quote - Chawla Ispat.`
      : "Chawla Ispat Rudrapur ki saari building material categories - TMT bar, GC/GP sheet, pipe, cement aur hardware.",
    chawlaispat
  );

  const crumbs = useMemo(() => {
    if (!catName) return null;
    return breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Categories", path: "/categories" },
      { name: catName, path: `/c/${slug.toLowerCase()}` },
    ]);
  }, [catName, slug]);
  useJsonLd("breadcrumb", crumbs);

  if (!list.length) {
    return (
      <div className="flex h-[50vh] items-center justify-center bg-ci-bg">
        <RingLoader color="#182A70" size={90} />
      </div>
    );
  }
  if (!hit) return <Navigate to="/categories" replace />;
  return (
    <Items
      categoryId={String(hit.id)}
      categoryName={catName}
      categoryDescription={String(hit.description || "")}
    />
  );
};

export default CategoryBySlug;
